
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "info_c1eb5766712653a7__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1440 0v6075H0V0h1440z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "info_c1eb5766712653a7__b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm-.008 7c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 0 0 2.5 0v-3.5c0-.69-.56-1.25-1.25-1.25zM8 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#info_c1eb5766712653a7__a)",
  transform: "translate(-878 -2364)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#info_c1eb5766712653a7__b)",
  transform: "translate(878 2364)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M0 0h16v16H0V0z"
})))));

      const __svgRaw = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <defs>\r\n        <clipPath id=\"iykfip4jua\">\r\n            <path d=\"M1440 0v6075H0V0h1440z\"/>\r\n        </clipPath>\r\n        <clipPath id=\"hz5ufaxdob\">\r\n            <path d=\"M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm-.008 7c-.69 0-1.25.56-1.25 1.25v3.5a1.25 1.25 0 0 0 2.5 0v-3.5c0-.69-.56-1.25-1.25-1.25zM8 3a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z\"/>\r\n        </clipPath>\r\n    </defs>\r\n    <g clip-path=\"url(#iykfip4jua)\" transform=\"translate(-878 -2364)\">\r\n        <g clip-path=\"url(#hz5ufaxdob)\" transform=\"translate(878 2364)\">\r\n            <path fill=\"var(--theme-primary, #810ea9)\" d=\"M0 0h16v16H0V0z\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/info.c1eb5766712653a7be8357c9bdf64253.svg"),
        {
          React: SvgInfo,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      